import React from 'react';
import {
    SkeletonContainer,
    SkeletonList,
    SkeletonCard,
    SkeletonCardItem,
    SkeletonCardTop,
    SkeletonCardTopDate,
    SkeletonCardTopDescr,
    SkeletonButtonWrapper,
    SkeletonButton,
    SkeletonDot,
    SkeletonLine,
} from '../styled';
import { detectMobile } from '../../../utils/UiHelper';
import { SkeletonAnimation } from '../skeletonAnimation';

const BetBuilderSkeleton = ({
    itemCount = detectMobile() ? 5 : 8,
    isEventPage = false,
    lines = isEventPage ? 4 : 3,
}) => {
    const isMobile = detectMobile();
    const renderSkeletonCard = () =>
        Array.from({ length: itemCount }, (_, index) => (
            <SkeletonCard
                key={`${index}_card`}
                width={isEventPage && !isMobile ? '347px' : '240px'}
            >
                {!isEventPage && (
                    <SkeletonCardTop key={`${index}_top`}>
                        <SkeletonCardTopDescr key={`${index}_descr`}>
                            <SkeletonCardItem width={'auto'}>
                                <SkeletonLine height={'10px'} width={'104px'} />
                            </SkeletonCardItem>

                            <SkeletonCardItem width={'auto'}>
                                <SkeletonLine height={'10px'} width={'127px'} />
                            </SkeletonCardItem>

                            <SkeletonCardItem width={'auto'}>
                                <SkeletonLine
                                    height={'10px'}
                                    width={'75px'}
                                    margin={'0 0 16px'}
                                />
                            </SkeletonCardItem>
                        </SkeletonCardTopDescr>
                        <SkeletonCardTopDate key={`${index}_date`}>
                            <SkeletonCardItem width={'auto'}>
                                <SkeletonLine
                                    height={'8px'}
                                    width={'51px'}
                                    margin={'0 0 10px'}
                                />
                            </SkeletonCardItem>
                            <SkeletonCardItem width={'auto'}>
                                <SkeletonLine height={'10px'} width={'40px'} />
                            </SkeletonCardItem>
                        </SkeletonCardTopDate>
                    </SkeletonCardTop>
                )}

                {Array.from({ length: lines }, (_, linesIndex) => (
                    <SkeletonCardItem
                        key={`${index}_line_${linesIndex}`}
                        margin={linesIndex === 0 ? '0' : '6px 0 0 '}
                    >
                        <SkeletonDot size={'8px'} />
                        <SkeletonLine
                            height={'8px'}
                            width={linesIndex % 2 === 0 ? '137px' : '104px'}
                            margin={'0'}
                        />
                    </SkeletonCardItem>
                ))}

                <SkeletonButtonWrapper isEventPage={isEventPage && !isMobile}>
                    <SkeletonButton
                        width={isEventPage && !isMobile ? '137px' : '157px'}
                    />
                </SkeletonButtonWrapper>
            </SkeletonCard>
        ));

    return (
        <SkeletonContainer margin={'0 0 12px'} isMobile={isMobile}>
            <SkeletonList>{renderSkeletonCard()}</SkeletonList>
            <SkeletonAnimation />
        </SkeletonContainer>
    );
};

export default BetBuilderSkeleton;
